import ol from 'openlayers'
import qualito from '../../../public/pictures/markers/map_quality2.png'
//import pluviometer from '../../../public/pictures/markers/map_pluvio.png'
import map_pluvio from '../../../public/pictures/markers/map_pluvio2.png'
import piezometer from '../../../public/pictures/markers/map_piezo2.png'
import hydro from '../../../public/pictures/markers/map_hydro2.png'
import seaport from '../../../public/pictures/markers/map_maregraphe2.png'
import industrialSite from '../../../public/pictures/markers/map_industrial_site.png'
import treatment from '../../../public/pictures/markers/map_Assainissement2.png'
import pollutedSoil from '../../../public/pictures/markers/map_polluted_soil.png'
import deposit from '../../../public/pictures/markers/mapmarker_blue_default.gif'
import undefined from '../../../public/pictures/markers/mapmarker_blue_default.gif'
import samplingSurfacePoint from '../../../public/pictures/markers/map_sampling_point.png'
//import agricoleExploitation from '../../../public/pictures/markers/map_agricultureExploitation.svg'
import mairie from '../../../public/pictures/markers/map_mairie.png'
import fishingPlace from '../../../public/pictures/markers/map_fishing_place.png'
import cavity from '../../../public/pictures/markers/map_cavity.png'

const singularPlural = (number, value = 's') => {
	if (number > 1) {
		return value
	}
	return ''
}

const createIconStyle = (imgsrc) => {
	return new ol.style.Style({
		image: new ol.style.Icon(({
			scale: 0.15,
			anchor: [0.5, 0.5],
			src: imgsrc
		})),
		zIndex: 1
	})
}

const createIconStyleHover = (imgsrc) => {
	const result = new ol.style.Style({
		image: new ol.style.Icon(({
			scale: 0.35,
			anchor: [0.5, 0.75],
			src: imgsrc
		})),
		zIndex: 99
	})
	result.setZIndex(99)
	return result
}

export default {
	getType: function (typeId, types) {
		const dataFilter = types.find((type) => {
			return type.id == typeId
		})
		if (dataFilter && dataFilter.parameter && this[dataFilter.parameter]) {
			return this[dataFilter.parameter]
		}
		return this.UNDEFINED
	},
	getTypeByParameter: function (parameter, types) {
		const dataFilter = types.find((type) => {
			return type.parameter == parameter
		})
		return dataFilter ? dataFilter : undefined
	},
	QUALITOMETER: {
		img: createIconStyle(qualito),
		name: (nb) => {
			return 'Qualitomètre' + singularPlural(nb) + ' souterrain' + singularPlural(nb)
		},
		title: 'Qualitomètre souterrain',
		type: 'QUALITOMETER',
		icon: qualito,
		dataType: ['QUALITOMETER_ANALYSIS']
	},
	QUALITOMETER_SURFACE: {
		img: createIconStyle(qualito),
		name: (nb) => {
			return 'Qualitomètre' + singularPlural(nb) + ' de surface'
		},
		title: 'Qualitomètre surface',
		type: 'QUALITOMETER_SURFACE',
		icon: qualito,
		dataType: [
			'QUALITOMETER_ANALYSIS',
			'QUALITOMETER_ANALYSIS_HYDROMORPHO',
			'QUALITOMETER_ANALYSIS_HYDROBIO'
		]

	},
	PLUVIOMETER: {
		img: createIconStyle(map_pluvio),
		name: (nb) => {
			return 'Station' + singularPlural(nb) + ' météo'
		},
		title: 'Station météo',
		type: 'PLUVIOMETER',
		icon: map_pluvio,
		dataType: [
			'PLUVIOMETER_RAIN',
			'PLUVIOMETER_NEBULOSITE',
			'PLUVIOMETER_PRESSION',
			'PLUVIOMETER_WIND_FORCE',
			'PLUVIOMETER_WIND_DIRECTION',
			'PLUVIOMETER_SNOW',
			'PLUVIOMETER_SNOW_TOTAL'
		]
	},
	PIEZOMETER: {
		img: createIconStyle(piezometer),
		name: (nb) => {
			return 'Piézomètre' + singularPlural(nb)
		},
		title: 'Piézomètre',
		type: 'PIEZOMETER',
		icon: piezometer,
		dataType: ['PIEZOMETER_MEASURE']
	},
	PIEZOMETER_REFERENCE: {
		img: createIconStyle(piezometer),
		name: (nb) => {
			return 'Indicateur' + singularPlural(nb) + ' sécheresse'
		},
		title: 'Piézomètre de référence (SDAGE)',
		type: 'PIEZOMETER_REFERENCE',
		icon: piezometer,
		dataType: ['PIEZOMETER_REFERENCE_MEASURE']
	},
	HYDROLOGICAL_STATION: {
		img: createIconStyle(hydro),
		name: (nb) => {
			return 'Station' + singularPlural(nb) + ' hydrométrique' + singularPlural(nb)
		},
		title: 'Station hydrométrique',
		type: 'HYDROLOGICAL_STATION',
		icon: hydro,
		dataType: [
			'HYDROLOGICAL_DEBIT',
			'HYDROLOGICAL_HEIGHT'
		]
	},
	HYDROLOGICAL_SITE: {
		img: createIconStyle(hydro),
		name: (nb) => {
			return 'Site ' + singularPlural(nb) + ' hydrométrique' + singularPlural(nb)
		},
		title: 'Site hydrométrique',
		type: 'HYDROLOGICAL_SITE',
		icon: hydro,
		dataType: []
	},
	HYDROLOGICAL_INDICATOR: {
		img: createIconStyle(hydro),
		name: (nb) => {
			return 'Station' + singularPlural(nb) + ' hydrométrique' + singularPlural(nb) + ' de référence'
		},
		title: 'Station hydrométrique de référence (SDAGE)',
		type: 'HYDROLOGICAL_INDICATOR',
		icon: hydro,
		dataType: []
	},
	SEAPORT: {
		img: createIconStyle(seaport),
		name: (nb) => {
			return 'Marégraphe' + singularPlural(nb)
		},
		title: 'Marégraphe',
		type: 'SEAPORT',
		icon: seaport,
		dataType: ['SEAPORT_MEASURE']
	},
	INDUSTRIAL_SITE: {
		img: createIconStyle(industrialSite),
		name: (nb) => {
			return 'Site' + singularPlural(nb) + ' industriel' + singularPlural(nb)
		},
		title: 'Site industriel',
		type: 'INDUSTRIAL_SITE',
		icon: industrialSite,
		dataType: ['INDUSTRIAL_SITE_NUMBER']
	},
	OBSTACLE_FLOW: {
		img: createIconStyle(seaport),
		name: (nb) => {
			return 'Obstacle' + singularPlural(nb) + ' à l\'écoulement'
		},
		title: 'Obstacle à l\'écoulement',
		type: 'OBSTACLE_FLOW',
		icon: seaport,
		dataType: ['OBSTACLE_FLOW_STATION_NUMBER']
	},
	TREATMENT_STATION: {
		img: createIconStyle(treatment),
		name: (nb) => {
			return 'Station' + singularPlural(nb) + ' d\'épuration'
		},
		title: 'Station  d\'épuration',
		type: 'TREATMENT_STATION',
		icon: treatment,
		dataType: ['TREATMENT_STATION_NUMBER']
	},

	POLLUTED_SOIL: {
		img: createIconStyle(pollutedSoil),
		name: (nb) => {
			return 'Sol' + singularPlural(nb) + ' pollué' + singularPlural(nb)
		},
		title: 'Sol pollué',
		type: 'POLLUTED_SOIL',
		icon: pollutedSoil,
		dataType: ['POLLUTED_SOIL_NUMBER']
	},
	DEPOSIT: {
		img: createIconStyle(deposit),
		name: (nb) => {
			return 'Gisement' + singularPlural(nb)
		},
		title: 'Gisement',
		type: 'DEPOSIT',
		icon: deposit,
		dataType: []
	},
	SAMPLING_SURFACE_POINT: {
		img: createIconStyle(samplingSurfacePoint),
		name: (nb) => {
			return 'Point' + singularPlural(nb) + 'de prélèvement'
		},
		title: 'Point de prélèvement',
		type: 'SAMPLING_SURFACE_POINT',
		icon: samplingSurfacePoint,
		dataType: []

	},
	CITY: {
		img: createIconStyle(mairie),
		name: (nb) => {
			return 'Donnée' + singularPlural(nb) + ' communale' + singularPlural(nb)
		},
		title: 'Donnée communale',
		type: 'CITY',
		icon: mairie,
		dataType: ['CITY_NUMBER']

	},
	FISHING_PLACE: {
		img: createIconStyle(fishingPlace),
		name: (nb) => {
			return 'Lieu' + singularPlural(nb, 'x') + ' de pêche'
		},
		title: 'Lieu de pêche',
		type: 'FISHING_PLACE',
		icon: fishingPlace,
		dataType: ['FISHING_PLACE']

	},
	CAVITY: {
		img: createIconStyle(cavity),
		name: (nb) => {
			return 'Cavité' + singularPlural(nb, 's') + ' souterraine' + singularPlural(nb, 's')
		},
		title: 'Cavité souterraine',
		type: 'CAVITY',
		icon: cavity,
		dataType: ['CAVITY']

	},
	UNDEFINED: {
		img: createIconStyle(undefined),
		name: () => {
			return 'Pas de type défini'
		},
		title: 'Inconnu',
		type: 'UNDEFINED',
		icon: undefined,
		dataType: []
	},
	createIconStyleHover
}



// WEBPACK FOOTER //
// ./src/utils/mapUtils/SiteTypes.js